var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "coupon-send-config",
    },
    [
      _c(
        "el-form",
        {
          ref: "couponForm",
          staticClass: "coupon-send-form form-container",
          attrs: {
            model: _vm.formData,
            rules: _vm.formRules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-tabs",
            {
              staticClass: "config-tabs",
              attrs: { type: "border-card" },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c(
                "el-tab-pane",
                { attrs: { label: "基本信息", name: "basic" } },
                [
                  _c("div", { staticClass: "tab-page" }, [
                    _c("div", { staticClass: "form-cards-grid" }, [
                      _c("div", { staticClass: "section-card" }, [
                        _c("div", { staticClass: "section-card-header" }, [
                          _vm._v("\n                发放内容"),
                          _c("span", { staticClass: "required-star" }, [
                            _vm._v("*"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-card-body" },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "发放类型", prop: "sendType" },
                              },
                              [
                                _c(
                                  "el-radio-group",
                                  {
                                    attrs: { disabled: _vm.isEdit },
                                    on: { change: _vm.handleSendTypeChange },
                                    model: {
                                      value: _vm.formData.sendType,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.formData, "sendType", $$v)
                                      },
                                      expression: "formData.sendType",
                                    },
                                  },
                                  [
                                    _c("el-radio", { attrs: { label: 4 } }, [
                                      _vm._v(
                                        "\n                      套券\n                    "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c("el-radio", { attrs: { label: 1 } }, [
                                      _vm._v(
                                        "\n                      单品券\n                    "
                                      ),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { "label-width": "0" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "bonus-list-wrapper" },
                                  [
                                    _vm.formData.sendType === 4
                                      ? _c(
                                          "el-select",
                                          {
                                            staticStyle: {
                                              width: "100%",
                                              "max-width": "400px",
                                            },
                                            attrs: {
                                              placeholder: "请选择券包（套券）",
                                              filterable: "",
                                              size: "small",
                                            },
                                            on: {
                                              change: _vm.handlePackageChange,
                                            },
                                            model: {
                                              value: _vm.selectedPackageId,
                                              callback: function ($$v) {
                                                _vm.selectedPackageId = $$v
                                              },
                                              expression: "selectedPackageId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.couponPackagesList,
                                            function (pkg) {
                                              return _c(
                                                "el-option",
                                                {
                                                  key: pkg.id,
                                                  attrs: {
                                                    label:
                                                      pkg.crmPackageId +
                                                      "-" +
                                                      pkg.packageName,
                                                    value: pkg.id,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        display: "flex",
                                                        "justify-content":
                                                          "space-between",
                                                        "align-items": "center",
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            pkg.crmPackageId
                                                          ) +
                                                            "-" +
                                                            _vm._s(
                                                              pkg.packageName
                                                            )
                                                        ),
                                                      ]),
                                                      _vm._v(" "),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            color: "#8492a6",
                                                            "font-size": "12px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              pkg.items
                                                                ? pkg.items
                                                                    .length
                                                                : 0
                                                            ) + "张券"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      : _c(
                                          "el-select",
                                          {
                                            staticStyle: {
                                              width: "100%",
                                              "max-width": "400px",
                                            },
                                            attrs: {
                                              placeholder: "请选择优惠券",
                                              filterable: "",
                                              size: "small",
                                            },
                                            on: {
                                              change: _vm.handleCouponChange,
                                            },
                                            model: {
                                              value: _vm.selectedCouponId,
                                              callback: function ($$v) {
                                                _vm.selectedCouponId = $$v
                                              },
                                              expression: "selectedCouponId",
                                            },
                                          },
                                          _vm._l(
                                            _vm.singleCouponOptions,
                                            function (opt) {
                                              return _c("el-option", {
                                                key: opt.key,
                                                attrs: {
                                                  label:
                                                    "[" +
                                                    opt.crmCouponId +
                                                    "] " +
                                                    opt.couponTitle,
                                                  value: opt.key,
                                                },
                                              })
                                            }
                                          ),
                                          1
                                        ),
                                    _vm._v(" "),
                                    _vm.selectedPackage
                                      ? _c(
                                          "div",
                                          { staticClass: "pkg-info-bar" },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "pkg-info-item" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "pkg-info-label",
                                                  },
                                                  [_vm._v("别名")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "pkg-info-val",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.selectedPackage
                                                          .packageAlias || "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.selectedPackage.oldPrice != null
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "pkg-info-item",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pkg-info-label",
                                                      },
                                                      [_vm._v("原价")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pkg-info-val price-strike",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "¥" +
                                                            _vm._s(
                                                              _vm.formatPrice(
                                                                _vm
                                                                  .selectedPackage
                                                                  .oldPrice
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.selectedPackage.price != null
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "pkg-info-item",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pkg-info-label",
                                                      },
                                                      [_vm._v("价格")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pkg-info-val price-buy",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "¥" +
                                                            _vm._s(
                                                              _vm.formatPrice(
                                                                _vm
                                                                  .selectedPackage
                                                                  .price
                                                              )
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.selectedPackage.packageDesc
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "pkg-info-item",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pkg-info-label",
                                                      },
                                                      [_vm._v("描述")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "pkg-info-val",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.selectedPackage
                                                              .packageDesc
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedPackage &&
                                    _vm.selectedPackage.items &&
                                    _vm.selectedPackage.items.length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "items-area" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "items-area-header",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "items-area-title",
                                                  },
                                                  [_vm._v("券明细")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "items-area-summary",
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                          共 " +
                                                        _vm._s(
                                                          _vm.displayItems
                                                            .length
                                                        ) +
                                                        " 种券\n                          "
                                                    ),
                                                    _vm.totalOldPrice > 0
                                                      ? [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "summary-sep",
                                                            },
                                                            [_vm._v("|")]
                                                          ),
                                                          _vm._v(
                                                            "\n                            原价合计 "
                                                          ),
                                                          _c("b", [
                                                            _vm._v(
                                                              "¥" +
                                                                _vm._s(
                                                                  _vm.formatPrice(
                                                                    _vm.totalOldPrice
                                                                  )
                                                                )
                                                            ),
                                                          ]),
                                                        ]
                                                      : _vm._e(),
                                                  ],
                                                  2
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "coupon-card-list",
                                              },
                                              _vm._l(
                                                _vm.displayItems,
                                                function (item) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: "item-" + item.id,
                                                      staticClass:
                                                        "coupon-card",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "coupon-card-main",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "coupon-card-info",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "coupon-card-name-row",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "coupon-id",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "[" +
                                                                          _vm._s(
                                                                            item.crmCouponId
                                                                          ) +
                                                                          "]"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "coupon-name",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          item.couponTitle
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "coupon-type-tag",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          _vm.getCouponTypeText(
                                                                            item.couponType
                                                                          )
                                                                        )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "coupon-card-meta",
                                                                },
                                                                [
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "别名：" +
                                                                        _vm._s(
                                                                          item.couponAlias ||
                                                                            "-"
                                                                        )
                                                                    ),
                                                                  ]),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "meta-dot",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "·"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      "发券数量：" +
                                                                        _vm._s(
                                                                          item.sendNum
                                                                        )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "coupon-card-prices",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "price-tag",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "price-tag-label",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "原价"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "price-tag-value text-gray",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "¥" +
                                                                          _vm._s(
                                                                            _vm.formatPrice(
                                                                              item.oldPrice !=
                                                                                null
                                                                                ? item.oldPrice
                                                                                : item.money
                                                                            )
                                                                          )
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  item.sendNum >
                                                                  1
                                                                    ? _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "price-tag-subtotal",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "小计 ¥" +
                                                                              _vm._s(
                                                                                _vm.formatPrice(
                                                                                  (item.oldPrice !=
                                                                                  null
                                                                                    ? item.oldPrice
                                                                                    : item.money) *
                                                                                    (item.sendNum ||
                                                                                      1)
                                                                                )
                                                                              )
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "coupon-card-controls",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "item-image-upload-inline",
                                                            },
                                                            [
                                                              _c(
                                                                "image-upload",
                                                                {
                                                                  staticClass:
                                                                    "coupon-image-upload",
                                                                  attrs: {
                                                                    prefix:
                                                                      _vm.imagePrefix,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.couponImgUrl,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "couponImgUrl",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.couponImgUrl",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "item-daily-inv",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v(
                                                                  "每日最多"
                                                                ),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "el-input-number",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "65px",
                                                                  },
                                                                  attrs: {
                                                                    min: _vm.getDailyInvMin(
                                                                      item
                                                                    ),
                                                                    max: 999999,
                                                                    "controls-position":
                                                                      "right",
                                                                    size: "small",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.dailyInv,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "dailyInv",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.dailyInv",
                                                                  },
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v("张"),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "field-tip-small",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "(0表示不限制)"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "item-total-inv",
                                                            },
                                                            [
                                                              _c("span", [
                                                                _vm._v("总共"),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "el-input-number",
                                                                {
                                                                  staticStyle: {
                                                                    width:
                                                                      "65px",
                                                                  },
                                                                  attrs: {
                                                                    min: _vm.getTotalNumMin(
                                                                      item
                                                                    ),
                                                                    max: 999999,
                                                                    "controls-position":
                                                                      "right",
                                                                    size: "small",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.totalNum,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "totalNum",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.totalNum",
                                                                  },
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c("span", [
                                                                _vm._v("张"),
                                                              ]),
                                                              _vm._v(" "),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "field-tip-small",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "(0表示不限制)"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _vm.formData.event ===
                                                          3
                                                            ? _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "item-time-range",
                                                                },
                                                                [
                                                                  _c(
                                                                    "span",
                                                                    {
                                                                      staticClass:
                                                                        "time-label",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "开始时间"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "el-time-picker",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          width:
                                                                            "180px",
                                                                        },
                                                                      attrs: {
                                                                        "is-range":
                                                                          "",
                                                                        "range-separator":
                                                                          "-",
                                                                        "start-placeholder":
                                                                          "开始",
                                                                        "end-placeholder":
                                                                          "结束",
                                                                        "value-format":
                                                                          "HH:mm",
                                                                        format:
                                                                          "HH:mm",
                                                                        size: "small",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          item.timeRange,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              item,
                                                                              "timeRange",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "item.timeRange",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            ),
                                          ]
                                        )
                                      : !_vm.selectedPackageId
                                      ? _c(
                                          "div",
                                          { staticClass: "empty-tip" },
                                          [
                                            _vm._v(
                                              "\n                      " +
                                                _vm._s(
                                                  _vm.formData.sendType === 4
                                                    ? "请先选择券包"
                                                    : "请选择优惠券"
                                                ) +
                                                "\n                    "
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          { staticClass: "empty-tip" },
                                          [
                                            _vm._v(
                                              "\n                      该券包暂无明细\n                    "
                                            ),
                                          ]
                                        ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-card" }, [
                        _c("div", { staticClass: "section-card-header" }, [
                          _vm._v("\n                基本信息\n              "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-card-body" },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "标题", prop: "title" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "400px" },
                                  attrs: {
                                    placeholder: "请输入活动标题",
                                    clearable: "",
                                  },
                                  model: {
                                    value: _vm.formData.title,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "title", $$v)
                                    },
                                    expression: "formData.title",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "活动时间", required: "" } },
                              [
                                _c("el-date-picker", {
                                  staticStyle: { width: "450px" },
                                  attrs: {
                                    type: "datetimerange",
                                    "range-separator": "至",
                                    "start-placeholder": "开始时间",
                                    "end-placeholder": "结束时间",
                                    format: "yyyy-MM-dd HH:mm:ss",
                                    "value-format": "yyyy-MM-dd HH:mm:ss",
                                    "default-time": ["00:00:00", "23:59:59"],
                                  },
                                  on: { change: _vm.handleDateChange },
                                  model: {
                                    value: _vm.dateRange,
                                    callback: function ($$v) {
                                      _vm.dateRange = $$v
                                    },
                                    expression: "dateRange",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "活动规则" } },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "450px" },
                                  attrs: {
                                    type: "textarea",
                                    rows: 12,
                                    placeholder: "非单独活动页，可不填写",
                                    maxlength: "1000",
                                    "show-word-limit": "",
                                  },
                                  model: {
                                    value: _vm.formData.rules,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "rules", $$v)
                                    },
                                    expression: "formData.rules",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "field-tip field-tip-red",
                                    staticStyle: { "margin-top": "4px" },
                                  },
                                  [
                                    _vm._v(
                                      "\n                    （折行，用回车标识）\n                  "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "是否有效" } },
                              [
                                _c("el-switch", {
                                  attrs: {
                                    "active-value": 1,
                                    "inactive-value": 0,
                                    "active-text": "有效",
                                    "inactive-text": "无效",
                                  },
                                  model: {
                                    value: _vm.formData.enabled,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.formData, "enabled", $$v)
                                    },
                                    expression: "formData.enabled",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "section-card" }, [
                        _c("div", { staticClass: "section-card-header" }, [
                          _vm._v("\n                发放设置\n              "),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "section-card-body" },
                          [
                            _c(
                              "el-form-item",
                              {
                                staticClass: "rule-note-item",
                                attrs: { "label-width": "0" },
                              },
                              [
                                _c("div", { staticClass: "rule-note" }, [
                                  _c(
                                    "div",
                                    { staticClass: "rule-note-title" },
                                    [
                                      _vm._v(
                                        "\n                      * 规则备注\n                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "rule-note-content" },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "* 一键领取，服务于一键领取所有券组合，例如：弹窗页面一键领取"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "* 领券中心，服务于单独的领取页面（完全自定义页面），可以单独领取每种优惠券"
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c("div", [
                                        _vm._v(
                                          "* 下单，根据订单条件自动发放优惠券"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.showEventSelector
                              ? _c(
                                  "el-form-item",
                                  {
                                    attrs: { label: "送券事件", prop: "event" },
                                  },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        attrs: {
                                          disabled:
                                            _vm.isEdit || _vm.eventFixed,
                                        },
                                        on: { change: _vm.handleEventChange },
                                        model: {
                                          value: _vm.formData.event,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.formData, "event", $$v)
                                          },
                                          expression: "formData.event",
                                        },
                                      },
                                      _vm._l(
                                        _vm.availableEventOptions,
                                        function (option) {
                                          return _c(
                                            "el-radio",
                                            {
                                              key: option.value,
                                              attrs: { label: option.value },
                                            },
                                            [
                                              _vm._v(
                                                "\n                      " +
                                                  _vm._s(option.label) +
                                                  "\n                    "
                                              ),
                                            ]
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.formData.event !== 3
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "发放人次" } },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        min: 0,
                                        max: 99999999,
                                        "controls-position": "right",
                                      },
                                      model: {
                                        value: _vm.formData.sendNum,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "sendNum", $$v)
                                        },
                                        expression: "formData.sendNum",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "field-tip" }, [
                                      _vm._v("（发放的总次数：0，没有限制）"),
                                    ]),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.showMaxTimes
                              ? _c(
                                  "el-form-item",
                                  { attrs: { label: "每人最多" } },
                                  [
                                    _c("el-input-number", {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        min: 0,
                                        max: 999999,
                                        "controls-position": "right",
                                      },
                                      model: {
                                        value: _vm.formData.consumeMaxTimes,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "consumeMaxTimes",
                                            $$v
                                          )
                                        },
                                        expression: "formData.consumeMaxTimes",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "field-tip" }, [
                                      _vm._v(_vm._s(_vm.maxTimesDescription)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "el-radio-group",
                                      {
                                        staticStyle: { "margin-left": "20px" },
                                        model: {
                                          value: _vm.formData.daily,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.formData, "daily", $$v)
                                          },
                                          expression: "formData.daily",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [
                                            _vm._v(
                                              "\n                      活动\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [
                                            _vm._v(
                                              "\n                      每日\n                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.formData.event === 6
                        ? _c("div", { staticClass: "section-card" }, [
                            _c("div", { staticClass: "section-card-header" }, [
                              _vm._v(
                                "\n                下单条件\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "section-card-body" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "消费金额条件" } },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.formData.orderConsume,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "orderConsume",
                                              $$v
                                            )
                                          },
                                          expression: "formData.orderConsume",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [
                                            _vm._v(
                                              "\n                      下单就送\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [
                                            _vm._v(
                                              "\n                      首购\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 2 } },
                                          [
                                            _vm._v(
                                              "\n                      复购\n                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "field-tip",
                                        staticStyle: { "margin-top": "8px" },
                                      },
                                      [
                                        _vm.formData.orderConsume === 1
                                          ? _c("span", [_vm._v("首次购买")])
                                          : _vm.formData.orderConsume === 2
                                          ? _c("span", [
                                              _vm._v(
                                                "距上次购买30天内再次购买"
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.formData.orderConsume !== -1
                                  ? [
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "消费金额" } },
                                        [
                                          _c("el-input-number", {
                                            staticStyle: { width: "200px" },
                                            attrs: {
                                              min: 0,
                                              max: 999999,
                                              precision: 2,
                                              "controls-position": "right",
                                            },
                                            model: {
                                              value:
                                                _vm.formData.conditionConsume,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "conditionConsume",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "formData.conditionConsume",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _vm.formData.orderConsume === 1
                                            ? _c(
                                                "span",
                                                { staticClass: "field-tip" },
                                                [
                                                  _vm._v(
                                                    "元，0表示不限制（首次购买）"
                                                  ),
                                                ]
                                              )
                                            : _vm.formData.orderConsume === 2
                                            ? _c(
                                                "span",
                                                { staticClass: "field-tip" },
                                                [
                                                  _vm._v(
                                                    "元，0表示不限制（距上次购买30天内再次购买）"
                                                  ),
                                                ]
                                              )
                                            : _c(
                                                "span",
                                                { staticClass: "field-tip" },
                                                [_vm._v("元，0表示不限制")]
                                              ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "订单实付" } },
                                        [
                                          _c("el-switch", {
                                            attrs: {
                                              "active-value": 1,
                                              "inactive-value": 0,
                                            },
                                            model: {
                                              value: _vm.formData.orderReal,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.formData,
                                                  "orderReal",
                                                  $$v
                                                )
                                              },
                                              expression: "formData.orderReal",
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "field-tip",
                                              staticStyle: {
                                                "margin-left": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "（选中后，订单实付金额满消费金额条件时发放）"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "订单场景" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "limit-config-item",
                                            },
                                            [
                                              _c(
                                                "el-checkbox-group",
                                                {
                                                  model: {
                                                    value:
                                                      _vm.formData.orderScenes,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData,
                                                        "orderScenes",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.orderScenes",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "el-checkbox",
                                                    { attrs: { label: 1 } },
                                                    [
                                                      _vm._v(
                                                        "\n                          堂食\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-checkbox",
                                                    { attrs: { label: 2 } },
                                                    [
                                                      _vm._v(
                                                        "\n                          自提\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "el-checkbox",
                                                    { attrs: { label: 3 } },
                                                    [
                                                      _vm._v(
                                                        "\n                          外卖\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    "margin-left": "20px",
                                                  },
                                                  attrs: {
                                                    type: "text",
                                                    size: "small",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.toggleAllOrderScenes,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        " +
                                                      _vm._s(
                                                        _vm.isAllOrderScenesSelected
                                                          ? "取消全选"
                                                          : "全选"
                                                      ) +
                                                      "\n                      "
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "选择门店" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "limit-config-item",
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    icon: "el-icon-plus",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.openStoreSelector,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        选择门店\n                      "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.selectedStoreList.length > 0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "selected-count",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "已选择 " +
                                                          _vm._s(
                                                            _vm
                                                              .selectedStoreList
                                                              .length
                                                          ) +
                                                          " 家门店"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _vm.selectedStoreList.length > 0
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "selected-goods-list",
                                                },
                                                _vm._l(
                                                  _vm.selectedStoreList,
                                                  function (store) {
                                                    return _c(
                                                      "el-tag",
                                                      {
                                                        key: store.id,
                                                        staticStyle: {
                                                          margin: "4px",
                                                        },
                                                        attrs: {
                                                          closable: "",
                                                          size: "small",
                                                        },
                                                        on: {
                                                          close: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeStore(
                                                              store.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              store.storeName
                                                            ) +
                                                            "\n                      "
                                                        ),
                                                      ]
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "field-tip field-tip-danger",
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "tip-icon" },
                                                [_vm._v("⚠")]
                                              ),
                                              _vm._v(
                                                " 若不选择则默认全部门店\n                    "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "指定商品" } },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "goods-selector" },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    icon: "el-icon-plus",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.openGoodsSelector,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        选择商品\n                      "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.selectedGoodsList.length > 0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "selected-count",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "已选择 " +
                                                          _vm._s(
                                                            _vm
                                                              .selectedGoodsList
                                                              .length
                                                          ) +
                                                          " 件商品"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("el-button", {
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                },
                                                attrs: {
                                                  size: "small",
                                                  icon: "el-icon-delete",
                                                  circle: "",
                                                  disabled:
                                                    _vm.selectedGoodsList
                                                      .length === 0,
                                                },
                                                on: {
                                                  click: _vm.handleClearGoods,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _vm.selectedGoodsList.length > 0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "selected-goods-list",
                                                    },
                                                    _vm._l(
                                                      _vm.selectedGoodsList,
                                                      function (goods) {
                                                        return _c(
                                                          "el-tag",
                                                          {
                                                            key: goods.goodsCode,
                                                            staticStyle: {
                                                              margin: "4px",
                                                            },
                                                            attrs: {
                                                              closable: "",
                                                              size: "small",
                                                            },
                                                            on: {
                                                              close: function (
                                                                $event
                                                              ) {
                                                                return _vm.removeGoods(
                                                                  goods.goodsCode
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  goods.goodsName
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-form-item",
                                        { attrs: { label: "菜品分类" } },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "category-selector",
                                            },
                                            [
                                              _c(
                                                "el-button",
                                                {
                                                  attrs: {
                                                    size: "small",
                                                    icon: "el-icon-plus",
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.openCategorySelector,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                        选择分类\n                      "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _vm.selectedCategoryList.length >
                                              0
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "selected-count",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "已选择 " +
                                                          _vm._s(
                                                            _vm
                                                              .selectedCategoryList
                                                              .length
                                                          ) +
                                                          " 个分类"
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c("el-button", {
                                                staticStyle: {
                                                  "margin-left": "10px",
                                                },
                                                attrs: {
                                                  size: "small",
                                                  icon: "el-icon-delete",
                                                  circle: "",
                                                  disabled:
                                                    _vm.selectedCategoryList
                                                      .length === 0,
                                                },
                                                on: {
                                                  click:
                                                    _vm.handleClearCategories,
                                                },
                                              }),
                                              _vm._v(" "),
                                              _vm.selectedCategoryList.length >
                                              0
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "selected-goods-list",
                                                    },
                                                    _vm._l(
                                                      _vm.selectedCategoryList,
                                                      function (catId) {
                                                        return _c(
                                                          "el-tag",
                                                          {
                                                            key: catId,
                                                            staticStyle: {
                                                              margin: "4px",
                                                            },
                                                            attrs: {
                                                              closable: "",
                                                              size: "small",
                                                            },
                                                            on: {
                                                              close: function (
                                                                $event
                                                              ) {
                                                                return _vm.removeCategory(
                                                                  catId
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  _vm.getCategoryName(
                                                                    catId
                                                                  )
                                                                ) +
                                                                "\n                        "
                                                            ),
                                                          ]
                                                        )
                                                      }
                                                    ),
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showUserType
                        ? _c("div", { staticClass: "section-card" }, [
                            _c("div", { staticClass: "section-card-header" }, [
                              _vm._v(
                                "\n                用户限制\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "section-card-body" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "用户类型" } },
                                  [
                                    _c(
                                      "el-radio-group",
                                      {
                                        model: {
                                          value: _vm.formData.userType,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.formData,
                                              "userType",
                                              $$v
                                            )
                                          },
                                          expression: "formData.userType",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 0 } },
                                          [
                                            _vm._v(
                                              "\n                      所有\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 1 } },
                                          [
                                            _vm._v(
                                              "\n                      新用户\n                    "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "el-radio",
                                          { attrs: { label: 2 } },
                                          [
                                            _vm._v(
                                              "\n                      老用户\n                    "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.formData.userType !== 1
                                  ? _c(
                                      "el-form-item",
                                      { attrs: { label: "用户级别" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "limit-config-item" },
                                          [
                                            _c(
                                              "el-checkbox-group",
                                              {
                                                model: {
                                                  value: _vm.userRankList,
                                                  callback: function ($$v) {
                                                    _vm.userRankList = $$v
                                                  },
                                                  expression: "userRankList",
                                                },
                                              },
                                              _vm._l(
                                                _vm.userRankOptions,
                                                function (rank) {
                                                  return _c(
                                                    "el-checkbox",
                                                    {
                                                      key: rank.id,
                                                      attrs: { label: rank.id },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(rank.name) +
                                                          "\n                      "
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              1
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "el-button",
                                              {
                                                staticStyle: {
                                                  "margin-left": "20px",
                                                },
                                                attrs: {
                                                  size: "small",
                                                  type: "text",
                                                },
                                                on: {
                                                  click: _vm.selectAllUserRanks,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.isAllUserRanksSelected
                                                        ? "取消全选"
                                                        : "全选"
                                                    ) +
                                                    "\n                    "
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "企微用户" } },
                                  [
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0,
                                        "active-text": "启用",
                                        "inactive-text": "不限",
                                      },
                                      model: {
                                        value: _vm.formData.isQwe,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.formData, "isQwe", $$v)
                                        },
                                        expression: "formData.isQwe",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "field-tip",
                                        staticStyle: { "margin-left": "10px" },
                                      },
                                      [_vm._v("（仅限企微用户参加）")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "form-actions" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "medium",
                              loading: _vm.submitLoading,
                            },
                            on: { click: _vm.handleSubmit },
                          },
                          [_vm._v("\n              确认\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { size: "medium" },
                            on: { click: _vm.handleReset },
                          },
                          [_vm._v("\n              重置\n            ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _vm.shouldShowThemeTab
                ? _c(
                    "el-tab-pane",
                    { attrs: { label: "主题信息", name: "theme" } },
                    [
                      _c("div", { staticClass: "tab-page" }, [
                        _c("div", { staticClass: "form-cards-grid" }, [
                          _c("div", { staticClass: "section-card" }, [
                            _c("div", { staticClass: "section-card-header" }, [
                              _vm._v(
                                "\n                主题配色\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "section-card-body" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "前景色" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "color-picker-row" },
                                      [
                                        _c("el-color-picker", {
                                          attrs: { "color-format": "hex" },
                                          model: {
                                            value: _vm.formData.theme.fgColor,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.theme,
                                                "fgColor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.theme.fgColor",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticClass: "color-input-inline",
                                          attrs: { placeholder: "#98CAC1" },
                                          model: {
                                            value: _vm.formData.theme.fgColor,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.theme,
                                                "fgColor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.theme.fgColor",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "color-preview-box",
                                          style: {
                                            backgroundColor:
                                              _vm.formData.theme.fgColor,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "背景色" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "color-picker-row" },
                                      [
                                        _c("el-color-picker", {
                                          attrs: { "color-format": "hex" },
                                          model: {
                                            value: _vm.formData.theme.bgColor,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.theme,
                                                "bgColor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.theme.bgColor",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("el-input", {
                                          staticClass: "color-input-inline",
                                          attrs: { placeholder: "#1A4D38" },
                                          model: {
                                            value: _vm.formData.theme.bgColor,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.theme,
                                                "bgColor",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.theme.bgColor",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "color-preview-box",
                                          style: {
                                            backgroundColor:
                                              _vm.formData.theme.bgColor,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "section-card" }, [
                            _c("div", { staticClass: "section-card-header" }, [
                              _vm._v(
                                "\n                页面设置\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "section-card-body" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "页面主题图" } },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "upload-section" },
                                      [
                                        _c("image-upload", {
                                          staticClass: "banner-upload",
                                          attrs: {
                                            prefix: _vm.imagePrefix,
                                            "upload-type": "banner",
                                          },
                                          model: {
                                            value: _vm.formData.theme.bannerUrl,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.theme,
                                                "bannerUrl",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.theme.bannerUrl",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "upload-tip" },
                                          [_vm._v("推荐尺寸：686px × 160px")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "section-card" }, [
                            _c("div", { staticClass: "section-card-header" }, [
                              _vm._v(
                                "\n                分享设置\n              "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "section-card-body" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "可否分享" } },
                                  [
                                    _c("el-switch", {
                                      attrs: {
                                        "active-value": 1,
                                        "inactive-value": 0,
                                      },
                                      model: {
                                        value: _vm.formData.canShare,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.formData,
                                            "canShare",
                                            $$v
                                          )
                                        },
                                        expression: "formData.canShare",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _vm.formData.canShare === 1
                                  ? _c(
                                      "el-form-item",
                                      { attrs: { label: "分享标题" } },
                                      [
                                        _c("el-input", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            placeholder: "请输入分享标题",
                                            clearable: "",
                                          },
                                          model: {
                                            value:
                                              _vm.formData.theme.shareTitle,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.formData.theme,
                                                "shareTitle",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "formData.theme.shareTitle",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.canShare === 1
                                  ? _c(
                                      "el-form-item",
                                      { attrs: { label: "分享卡片图" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "upload-section" },
                                          [
                                            _c("image-upload", {
                                              staticClass: "share-upload",
                                              attrs: {
                                                prefix: _vm.imagePrefix,
                                                "upload-type": "share",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.theme
                                                    .shareImgUrl,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData.theme,
                                                    "shareImgUrl",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.theme.shareImgUrl",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "upload-tip" },
                                              [
                                                _vm._v(
                                                  "推荐尺寸：686px × 375px"
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.formData.event === 3
                                  ? _c(
                                      "el-form-item",
                                      { attrs: { label: "分享图标" } },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "upload-section" },
                                          [
                                            _c("image-upload", {
                                              staticClass: "share-icon-upload",
                                              attrs: {
                                                prefix: _vm.imagePrefix,
                                                "upload-type": "share-icon",
                                              },
                                              model: {
                                                value:
                                                  _vm.formData.theme
                                                    .shareIconUrl,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.formData.theme,
                                                    "shareIconUrl",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "formData.theme.shareIconUrl",
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              { staticClass: "upload-tip" },
                                              [_vm._v("分享图标（小标）")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _vm.formData.event === 3
                            ? _c("div", { staticClass: "section-card" }, [
                                _c(
                                  "div",
                                  { staticClass: "section-card-header" },
                                  [
                                    _vm._v(
                                      "\n                规则设置\n              "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "section-card-body" },
                                  [
                                    _vm.formData.event === 3
                                      ? _c(
                                          "el-form-item",
                                          { attrs: { label: "规则背景" } },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "upload-section" },
                                              [
                                                _c("image-upload", {
                                                  staticClass: "rule-bg-upload",
                                                  attrs: {
                                                    prefix: _vm.imagePrefix,
                                                    "upload-type": "rule-bg",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.theme
                                                        .ruleUrl,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.theme,
                                                        "ruleUrl",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.theme.ruleUrl",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "upload-tip" },
                                                  [_vm._v("规则背景图")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.formData.event === 3
                                      ? _c(
                                          "el-form-item",
                                          { attrs: { label: "规则图标" } },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "upload-section" },
                                              [
                                                _c("image-upload", {
                                                  staticClass:
                                                    "rule-icon-upload",
                                                  attrs: {
                                                    prefix: _vm.imagePrefix,
                                                    "upload-type": "rule-icon",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.formData.theme
                                                        .ruleIconUrl,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.formData.theme,
                                                        "ruleIconUrl",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "formData.theme.ruleIconUrl",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  { staticClass: "upload-tip" },
                                                  [_vm._v("规则图标（小标）")]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-actions" },
                          [
                            _c(
                              "el-button",
                              {
                                attrs: {
                                  type: "primary",
                                  size: "medium",
                                  loading: _vm.submitLoading,
                                },
                                on: { click: _vm.handleSubmit },
                              },
                              [_vm._v("\n              确认\n            ")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-button",
                              {
                                attrs: { size: "medium" },
                                on: { click: _vm.handleReset },
                              },
                              [_vm._v("\n              重置\n            ")]
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择商品",
            visible: _vm.goodsSelectorVisible,
            width: "1000px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.goodsSelectorVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "goods-selector-dialog" },
            [
              _c(
                "div",
                { staticClass: "selector-toolbar" },
                [
                  _c("el-input", {
                    staticStyle: { width: "200px" },
                    attrs: { placeholder: "菜品编码/菜品名称", clearable: "" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.queryGoodsList($event)
                      },
                    },
                    model: {
                      value: _vm.goodsListQuery.keywords,
                      callback: function ($$v) {
                        _vm.$set(_vm.goodsListQuery, "keywords", $$v)
                      },
                      expression: "goodsListQuery.keywords",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-cascader", {
                    staticStyle: { width: "200px" },
                    attrs: {
                      options: _vm.categoryOptions,
                      props: {
                        value: "id",
                        label: "categoryName",
                        leaf: "leaf",
                        checkStrictly: true,
                      },
                      placeholder: "菜品分类",
                      clearable: "",
                    },
                    model: {
                      value: _vm.goodsListQuery.categories,
                      callback: function ($$v) {
                        _vm.$set(_vm.goodsListQuery, "categories", $$v)
                      },
                      expression: "goodsListQuery.categories",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "菜品类型", clearable: "" },
                      model: {
                        value: _vm.goodsListQuery.goodsType,
                        callback: function ($$v) {
                          _vm.$set(_vm.goodsListQuery, "goodsType", $$v)
                        },
                        expression: "goodsListQuery.goodsType",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "单品", value: "1" } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "套餐", value: "2" } }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-search" },
                      on: { click: _vm.queryGoodsList },
                    },
                    [_vm._v("\n          搜索\n        ")]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  attrs: {
                    data: _vm.goodsListData,
                    border: "",
                    stripe: "",
                    "max-height": "400",
                  },
                  on: { "selection-change": _vm.handleGoodsSelectionChange },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      width: "55",
                      selectable: _vm.checkGoodsSelectable,
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "菜品编码",
                      prop: "goodsCode",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "菜品名称",
                      prop: "goodsName",
                      "min-width": "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "菜品类型", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            row.goodsType == 1
                              ? _c("span", [_vm._v("单品")])
                              : _vm._e(),
                            _vm._v(" "),
                            row.goodsType == 2
                              ? _c("span", [_vm._v("套餐")])
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "所属大类",
                      prop: "categoryFirstName",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "所属小类",
                      prop: "categorySecondName",
                      width: "120",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "商品图", width: "100" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            !row.goodsThumbnailUrl ||
                            row.goodsThumbnailUrl === ""
                              ? _c("span", [_vm._v("未上传图片")])
                              : _c(
                                  "el-image",
                                  {
                                    staticStyle: {
                                      width: "60px",
                                      height: "40px",
                                    },
                                    attrs: {
                                      src: _vm.getGoodsImageUrl(
                                        row.goodsThumbnailUrl
                                      ),
                                      fit: "contain",
                                      "preview-src-list": [
                                        _vm.getGoodsImageUrl(
                                          row.goodsThumbnailUrl
                                        ),
                                      ],
                                      "preview-teleported": "",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "image-slot",
                                        attrs: { slot: "error" },
                                        slot: "error",
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "el-icon-picture-outline",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: { "margin-top": "16px", "text-align": "right" },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.goodsListQuery.page,
                      "page-size": _vm.goodsListQuery.limit,
                      total: _vm.goodsListTotal,
                      layout: "total, prev, pager, next",
                    },
                    on: { "current-change": _vm.handleGoodsPageChange },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.goodsSelectorVisible = false
                    },
                  },
                },
                [_vm._v("\n        取消\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmGoodsSelection },
                },
                [_vm._v("\n        确定\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择分类",
            visible: _vm.categorySelectorVisible,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.categorySelectorVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "category-selector-dialog" },
            [
              _c("el-tree", {
                ref: "categoryTree",
                staticStyle: { "max-height": "400px", "overflow-y": "auto" },
                attrs: {
                  data: _vm.categoryTreeData,
                  "show-checkbox": "",
                  "node-key": "id",
                  "default-checked-keys": _vm.selectedCategoryList,
                  props: { label: "categoryName", children: "children" },
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.categorySelectorVisible = false
                    },
                  },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmCategorySelection },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "选择门店",
            visible: _vm.storeSelectorVisible,
            width: "800px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.storeSelectorVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "store-selector-dialog" },
            [
              _c(
                "div",
                { staticClass: "store-selector-toolbar" },
                [
                  _c("el-input", {
                    staticStyle: { width: "300px" },
                    attrs: {
                      placeholder: "请输入关键字进行筛选",
                      "prefix-icon": "el-icon-search",
                      size: "small",
                      clearable: "",
                    },
                    model: {
                      value: _vm.storeSearchText,
                      callback: function ($$v) {
                        _vm.storeSearchText = $$v
                      },
                      expression: "storeSearchText",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "12px" },
                      attrs: { size: "small", type: "text" },
                      on: { click: _vm.selectAllStores },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.isAllStoresSelected ? "取消全选" : "全选"
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-tree", {
                ref: "storeTreeDialog",
                staticClass: "store-tree-dialog",
                attrs: {
                  data: _vm.storeTreeData,
                  "show-checkbox": "",
                  "node-key": "id",
                  "default-expanded-keys": _vm.storeExpandedKeys,
                  "default-checked-keys": _vm.storeCheckedKeys,
                  props: _vm.storeTreeProps,
                  "filter-node-method": _vm.filterStoreNode,
                },
                on: { "check-change": _vm.handleStoreCheckInDialog },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.storeSelectorVisible = false
                    },
                  },
                },
                [_vm._v("\n        取消\n      ")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmStoreSelection },
                },
                [_vm._v("\n        确定\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }